/* ==========================================================================
   Full Multilingual Article Translations (CS, EN, DE, ES, PT, AR)
   ========================================================================== */

import cs from './articles/articles_cs.json';
import en from './articles/articles_en.json';
import de from './articles/articles_de.json';
import es from './articles/articles_es.json';
import pt from './articles/articles_pt.json';
import ar from './articles/articles_ar.json';
import it from './articles/articles_it.json';

export const articleFullTranslations = {
  cs,
  en,
  de,
  es,
  pt,
  ar,
  it
};